__turbopack_context__.v({
  "prefix": "CompanyNumber-module-scss-module__HxkqQq__prefix",
});
